import { renderToStaticMarkup } from 'react-dom/server';
import type { TFunction } from 'i18next';
import SerpContentSnapshot from '@/components/Approval/@components/SerpContentSnapshot';
import { formatSerpText } from '@/utils/approval/serpDocument';
import {
  getSerpApStockTransferRows,
  type SerpApStockTransferSource,
} from '@/utils/approval/serpApStockTransfer';
import { SerpApStockTransferRoot } from './styles';

type TablesProps = {
  source: SerpApStockTransferSource;
  t: TFunction;
};

/** 레거시 #APV_SERP_AP_INVENTORY_TRANSFER .form-group 의 표 2개(브랜드·요청자는 응답 코드·아이디 그대로) */
const SerpApStockTransferTables = ({ source, t }: TablesProps) => (
  <>
    <table className="table table-bordered mb-30 text-center">
      <tbody>
        <tr>
          <th colSpan={2}>{t('AP재고이관')}</th>
        </tr>
        <tr>
          <th>{t('브랜드')}</th>
          <td id="brandCd">{formatSerpText(source.brandCd)}</td>
        </tr>
        <tr>
          <th>{t('요청번호')}</th>
          <td id="stkTrReqNo">{formatSerpText(source.stkTrReqNo)}</td>
        </tr>
        <tr>
          <th>{t('요청일자')}</th>
          <td id="reqDe">{formatSerpText(source.reqDe)}</td>
        </tr>
        <tr>
          <th>{t('요청자')}</th>
          <td id="reqrId">{formatSerpText(source.reqrId)}</td>
        </tr>
        <tr>
          <th>{t('요청사유')}</th>
          <td id="trRsn">{formatSerpText(source.trRsn)}</td>
        </tr>
      </tbody>
    </table>
    <table className="table table-bordered mb-30 text-center">
      <tbody id="stkTrReqDtlTable">
        <tr>
          <th colSpan={8}>{t('이관 대상 목록')}</th>
        </tr>
        <tr>
          <th>{t('시즌')}</th>
          <th>{t('스타일')}</th>
          <th>{t('컬러')}</th>
          <th>{t('사이즈')}</th>
          <th>{t('요청수량')}</th>
          <th>{t('승인수량')}</th>
          <th>{t('보내는 AP')}</th>
          <th>{t('받는 AP')}</th>
        </tr>
        {getSerpApStockTransferRows(source).map((item, index) => (
          <tr key={index}>
            <td>{formatSerpText(item.ssnCd)}</td>
            <td>{formatSerpText(item.prodCd)}</td>
            <td>{formatSerpText(item.colorCd)}</td>
            <td>{formatSerpText(item.sizCd)}</td>
            <td>{formatSerpText(item.reqQty)}</td>
            <td>{formatSerpText(item.signQty)}</td>
            <td>{formatSerpText(item.fromApNm)}</td>
            <td>{formatSerpText(item.toApNm)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </>
);

/** attributes.content — 레거시 조회 화면은 이 HTML 만 그대로 출력 */
export const buildSerpApStockTransferContentHtml = (
  source: SerpApStockTransferSource,
  t: TFunction,
): string =>
  renderToStaticMarkup(<SerpApStockTransferTables source={source} t={t} />);

/** 저장 content(레거시 문서 포함) 그대로 — 작성 화면도 같은 HTML 로 그림 */
export const SerpApStockTransferSnapshot = ({
  content,
}: {
  content: string;
}) => (
  <SerpApStockTransferRoot>
    <SerpContentSnapshot content={content} />
  </SerpApStockTransferRoot>
);
